function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M248.239 208.121H9.23901C5.10301 208.121 1.73901 204.757 1.73901 200.621V119.333C1.73901 116.382 3.38501 113.295 5.83601 111.651L124.015 32.4349C125.371 31.5249 127.005 31.0439 128.739 31.0439C130.473 31.0439 132.106 31.5249 133.464 32.4359L251.64 111.651C254.092 113.296 255.739 116.382 255.739 119.333V200.621C255.739 204.757 252.375 208.121 248.239 208.121ZM12.739 197.121H244.739V120.267L128.739 42.512L12.739 120.267V197.121Z",
  fill: "black"
});

function SvgIconHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.f990b8965a994bd45880e98ab1a78e80.svg";
export { ForwardRef as ReactComponent };